module.exports = __webpack_public_path__ + "img/104.10.8c0405fe.png";